import { render } from "./FolderPage.vue?vue&type=template&id=2db98a7b&scoped=true"
import script from "./FolderPage.vue?vue&type=script&lang=js"
export * from "./FolderPage.vue?vue&type=script&lang=js"

import "./FolderPage.vue?vue&type=style&index=0&id=2db98a7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db98a7b"]])

export default __exports__